module.exports = __webpack_public_path__ + "static/media/rap.57465a34.svg";